import React, { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import { IBannerData, IConsentLetters, ISurgicalData } from "../../exports/interfaces";
import { dynamicFailed } from "../../hooks/useToast";
import SurgicalDomainsBanner from "../../components/surgicaldomains/SurgicalDomainsBanner";
import SurgicalDomainsDescription from "../../components/surgicaldomains/SurgicalDomainsDescription";
import {
  fetchConsentLetters,
  fetchFatGrafting,
  fetchFatGraftingBanner,
} from "../../api/SurgicalDomainApi";

const FatGrafting = () => {
  const { setLoading } = useLoader();
  const [fatGraftingBanner, setFatGraftingBanner] = useState<IBannerData[]>([]);
  const [fatGraftingData, setFatGraftingData] = useState<ISurgicalData[]>([]);
  const [consentLetters, setConsentLetters] = useState<IConsentLetters[]>([]);

  useEffect(() => {
    setLoading(true);
    // Promise.all([fetchArchiveBanner(), fetchVideoData()])
    Promise.all([fetchFatGraftingBanner(), fetchFatGrafting(), fetchConsentLetters()])
      .then(([fatGraftingBannerData, fatGraftingData, consentLettersData]) => {
        setFatGraftingBanner(fatGraftingBannerData);
        setFatGraftingData(fatGraftingData);
        setConsentLetters(consentLettersData);
        // setArchiveVideoData(videoData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);
  return (
    <>
      <SurgicalDomainsBanner
        bannerData={fatGraftingBanner}
        page={"Fat Grafting"}
      />
      <SurgicalDomainsDescription descriptionData={fatGraftingData} consentLetters={consentLetters} surgicalName='Fat_Grafting'/>
    </>
  );
};

export default FatGrafting;
